import { render, staticRenderFns } from "./testLottery.vue?vue&type=template&id=8b4aa2e0&"
import script from "./testLottery.vue?vue&type=script&lang=js&"
export * from "./testLottery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports